import {
  useMemo } from "react";
  import { useTranslation } from "react-i18next";
  import {
  ShoppingOutlined,
  ClusterOutlined,
  CarOutlined,
  BarChartOutlined,
  AppstoreOutlined,
} from "@ant-design/icons";
import "../style.css";

const iconByIndex: Record<number, JSX.Element> = {
  0: <ShoppingOutlined />,
  1: <ClusterOutlined />,
  2: <CarOutlined />,
  3: <BarChartOutlined />,
};

const MINI_FUNNEL_WIDTHS = [100, 72, 52, 32];

const HighlightsSection = () => {
  const { t } = useTranslation("dms");

  const items = useMemo(() => {
    const raw = t("highlights.items", { returnObjects: true }) as unknown;
    if (!Array.isArray(raw)) return [];
    return raw as Array<{ title: string; desc: string }>;
  }, [t]);

  const funnel = useMemo(() => {
    const raw = t("highlights.funnel_mini", { returnObjects: true }) as unknown;
    if (!Array.isArray(raw)) return [];
    return raw as Array<{ key: string }>;
  }, [t]);

  const statValue = t("highlights.stat_value");
  const statLabel = t("highlights.stat_label");
  const statDesc = t("highlights.stat_desc");

  return (
    <section className="dev-dms-section dev-dms-highlights-section">
      <div className="dev-dms-section-inner">
        <h2 className="dev-section-h2 dev-dms-section-h2">
          <span className="dev-dms-section-h2-icon dev-dms-section-h2-icon--cyan" aria-hidden>
            <AppstoreOutlined />
          </span>
          <span>{t("highlights.title")}</span>
        </h2>

        <div className="dev-dms-highlights-grid">
          <div className="dev-dms-highlight-list">
            {items.map((item, idx) => (
              <div key={idx} className="dev-dms-highlight-item">
                <div className="dev-dms-highlight-icon">
                  {iconByIndex[idx] ?? <UserOutlined />}
                </div>
                <div>
                  <div className="dev-dms-highlight-title">{item.title}</div>
                  <div className="dev-dms-highlight-desc">{item.desc}</div>
                </div>
              </div>
            ))}
          </div>

          <div className="dev-dms-stat-card dev-dms-stat-card--funnel">
            <div className="dev-dms-stat-value">{statValue}</div>
            <div className="dev-dms-stat-label">{statLabel}</div>
            <div className="dev-dms-stat-desc">{statDesc}</div>
            <div className="dev-dms-stat-mini-funnel" aria-hidden>
              {funnel.map((tier, idx) => (
                <div
                  key={tier.key}
                  className={`dev-dms-stat-mini-bar dev-dms-stat-mini-bar--${tier.key}`}
                  style={{ width: `${MINI_FUNNEL_WIDTHS[idx] ?? 30}%` }}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HighlightsSection;
